/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialOnboardingProgressControllerFindForTrialQueryResponse, TrialOnboardingProgressControllerFindForTrialQueryParams, TrialOnboardingProgressControllerFindForTrial401, TrialOnboardingProgressControllerFindForTrial403 } from "../../models/trialOnboardingProgressController/TrialOnboardingProgressControllerFindForTrial";

function getTrialOnboardingProgressControllerFindForTrialUrl() {
  const res = { method: 'GET', url: `/api/v1/trial-onboarding-progress` as const }  
  return res
}

/**
 * @summary Get trial onboarding progress for the current user
 * {@link /api/v1/trial-onboarding-progress}
 */
export async function trialOnboardingProgressControllerFindForTrial(params: TrialOnboardingProgressControllerFindForTrialQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrialOnboardingProgressControllerFindForTrialQueryResponse, ResponseErrorConfig<TrialOnboardingProgressControllerFindForTrial401 | TrialOnboardingProgressControllerFindForTrial403>, unknown>({ method : "GET", url : getTrialOnboardingProgressControllerFindForTrialUrl().url.toString(), params, ... requestConfig })  
  return res.data
}